import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import addDays from 'date-fns/addDays';
import subDays from 'date-fns/subDays';
import parseISO from 'date-fns/parseISO';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import { MainImageThumbnail } from '../../../features/PpsiContainer/constants';
import TextField from '../../Form/Fields/TextField';
import FormulaVersionField from '../../Form/Fields/FormulaVersionField';
import SpacedTextField from '../../Form/Fields/SpacedTextField';
import DateField from '../../Form/Fields/DateField';
import FormContext from '../../Form/FormContext';
import SectionHeader from '../../Form/Fields/SectionHeader';
import ImageWithDropzone from '../../Image/ImageWithDropzone';
import { getIsGlobalUser } from '../../../features/loginSystem/selectors';
import { getLanguage, getConfigs } from '../../../features/app/selectors';

const useStyles = makeStyles(theme => ({
  mainImage: {
    width: '100%',
    marginTop: theme.spacing(2)
  }
}));

function toDate(date) {
  if (typeof date === 'string') {
    return parseISO(date);
  }
  return date;
}

const SchedulePublish = () => {
  const classes = useStyles();
  const language = useSelector(getLanguage);
  const isGlobalUser = useSelector(getIsGlobalUser);
  const { data, setFieldValue } = useContext(FormContext);
  const { targetPublishDate, targetUnpublishDate, mainImage } = data;
  const dateFormat = useSelector(getConfigs).toJS().dateFormat || 'yyyy-MM-dd';

  function getUnpublishMinDate() {
    if (targetPublishDate) {
      return addDays(toDate(targetPublishDate), 1);
    }
    return addDays(new Date(), 2);
  }

  function getPublishMinDate() {
    return addDays(new Date(), 1);
  }

  function getPublishMaxDate() {
    if (targetUnpublishDate) {
      return subDays(toDate(targetUnpublishDate), 1);
    }
    return null;
  }

  return (
    <Grid container spacing={4}>
      <Grid item sm={12} md={6}>
        <SectionHeader translationId="ppsi.publishHeader" />
        <Grid container spacing={2}>
          <Grid item sm={12} md={6}>
            <DateField
              label="ppsi.publishDateLabel"
              dataField="targetPublishDate"
              minDate={getPublishMinDate()}
              maxDate={getPublishMaxDate()}
              dateFormat={dateFormat}
              helperText={
                isGlobalUser
                  ? 'ppsi.publishDateHelperTextIFS'
                  : 'ppsi.publishDateHelperTextLocal'
              }
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <DateField
              label="ppsi.unpublishDateLabel"
              dataField="targetUnpublishDate"
              minDate={getUnpublishMinDate()}
              dateFormat={dateFormat}
              helperText={
                isGlobalUser
                  ? 'ppsi.unpublishDateHelperTextIFS'
                  : 'ppsi.unpublishDateHelperTextLocal'
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SchedulePublish;
